import { render, staticRenderFns } from "./serverDown.vue?vue&type=template&id=4f8d2392&"
import script from "./serverDown.vue?vue&type=script&lang=ts&"
export * from "./serverDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports